import {useCanvasStore} from './canvas-store';
import type {CommentPopoverState} from './canvas-types';
import {CommentPinEditor} from './comment-pin-editor';

export function CanvasCommentPin({popover}:{popover:CommentPopoverState}){
 const {addComment,removeComment,editComment,setCommentPopover,comments}=useCanvasStore();
 return <CommentPinEditor popover={popover} addComment={addComment} removeComment={removeComment} editComment={editComment} setCommentPopover={setCommentPopover} comments={comments}/>;
}
